import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import VueTruncate from "vue-truncate-filter";
Vue.use(VueTruncate);

Vue.prototype.$liff = window.liff;

import numeral from "numeral";

Vue.filter("numberFormat", function (value) {
  return numeral(value).format("0,0");
});

Vue.filter("decimalFormat", function (value) {
  return numeral(value).format("0,0.00");
});

Vue.filter("getTuinui", function (tuinui_id) {
  if (tuinui_id == 1) {
    return "หัวเขียว";
  } else if (tuinui_id == 2) {
    return "เขาแดง";
  } else if (tuinui_id == 3) {
    return "ลายจุด";
  } else if (tuinui_id == 4) {
    return "ปรกติ";
  } else if (tuinui_id == 5) {
    return "หน้าหมู";
  } else if (tuinui_id == 6) {
    return "ก้ามปู";
  } else if (tuinui_id == 7) {
    return "เอเลี่ยน";
  } else if (tuinui_id == 8) {
    return "บรรพบุรุษ";
  } else if (tuinui_id == 9) {
    return "หัวโจก";
  } else if (tuinui_id == 10) {
    return "ผู้ดี";
  } else if (tuinui_id == 11) {
    return "โอ่งมังกร";
  } else if (tuinui_id == 12) {
    return "แครอท";
  } else if (tuinui_id == 13) {
    return "ต้นไม้";
  } else if (tuinui_id == 14) {
    return "โคนม";
  } else if (tuinui_id == 15) {
    return "ราชา";
  } else if (tuinui_id == 16) {
    return "เมือก";
  } else if (tuinui_id == 17) {
    return "โครงกระดูก";
  } else if (tuinui_id == 18) {
    return "นักกล้าม";
  } else if (tuinui_id == 19) {
    return "ทองคำ";
  } else if (tuinui_id == 20) {
    return "เดอะฮัค";
  } else if (tuinui_id == 21) {
    return "นักมวยปล้ำ";
  } else if (tuinui_id == 22) {
    return "นางเงือก";
  } else if (tuinui_id == 23) {
    return "แกะ";
  } else if (tuinui_id == 24) {
    return "สิงโต";
  } else if (tuinui_id == 25) {
    return "ยูนิคอร์น";
  } else if (tuinui_id == 26) {
    return "ยักษ์วัดแจ้ง";
  } else if (tuinui_id == 27) {
    return "บาบีก้อน";
  } else if (tuinui_id == 28) {
    return "กรรมการ";
  } else if (tuinui_id == 29) {
    return "ซูโม่";
  } else if (tuinui_id == 30) {
    return "ซามูไร";
  } else if (tuinui_id == 31) {
    return "อัศวิน";
  } else if (tuinui_id == 32) {
    return "สฟิงซ์";
  } else if (tuinui_id == 33) {
    return "ชาวป่า";
  } else if (tuinui_id == 34) {
    return "จินนี่";
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
